/*=========================================================================================
  File Name: state.js
  Description: Order Manager Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Order Manager State Module
  Author: Tan Tran

    Pending,//0
    InProgress,//1 
    Scheduled,//2
    Ready,//3
    Unmanaged//4
    Delivered //5
==========================================================================================*/
import moment from 'moment'
export default {

    ADD_NEW_ORDER_STATE ( state, payload) {
      console.log(payload);
      let newOrder = {
        orderId : payload.orderId,
        pickupNumber : payload.pickupNumber,
        createdDate : payload.createdDate,
        pickupTime : payload.pickupTime,
        startTime : payload.startTime,
        endTime : payload.endTime,
        state : payload.state,
        status : payload.status,
        isPaid : payload.isPaid,
        orderedBy : payload.orderedBy,
        customerId : payload.customerId,
        customerName : payload.customerName,
        phoneNumber : payload.phoneNumber,
        email : payload.email,
        amount : payload.amount,
        discount : payload.discount,
        totalItems : payload.totalItems,
        comment : payload.comment,
        orderDetails : payload.orderDetails
      };
      state.orders.push(newOrder);
    },

    SET_CURRENTORDERS_STATE (state, payload) {
      state.orders = payload;
    },

    SET_ORDER_TO_READY_STATE (state, payload) {

      console.log('SET_ORDER_TO_READY_STATE');
      console.log(payload)

      let index = state.orders.findIndex(order =>  { return order.orderId === payload.orderId });
      console.log('SET_ORDER_TO_READY_STATE');
      if (index > -1) {
        state.orders[index].state = 3;
      }
    },

    SET_PENDING_TO_INPROGRESS_STATE(state, payload) {
      console.log('SET_PENDING_TO_INPROGRESS_STATE');
      let nextIndex = state.orders.findIndex(order => {return order.orderId === payload.nextOrder});
      
      if(nextIndex > -1) {
        state.orders[nextIndex].state = 1;
      }
    },

    

    UPDATE_PROGRESS_STATE (state, payload) {
      state.progress = Math.ceil((state.inProgressOrders.length / (state.inProgressOrders.length + state.pendingOrders.length)) * 100);
    },

    UPDATE_RESET_STATE (state, payload) {
      state.resetState = payload;
    },


    SET_CURRENT_WAITING_TIME_STATE (state, payload) {
      state.currentWaitingTime = payload;
    },

    SET_CAPACITY_STATE (state, payload) {
      state.capacity = payload;
    },


    SET_ORDER_PICKUP_DATE_STATE (state, payload) {
      console.log('SET_ORDER_PICKUP_DATE_STATE')
      console.log(payload)
      let index = state.orders.findIndex(i => { return i.orderId === payload.orderId});
      if(index > -1) {
        state.orders[index].pickupTime = payload.newPickupTime;
        state.orders[index].state = payload.state;
      }
    },

    SET_ORDER_MANAGER_STATE(state, payload) {
      state.orderManagerState.capacity = payload.capacity;
      state.orderManagerState.currentWaitingTime = payload.currentWaitingTime;
      state.orderManagerState.minWaitingTime = payload.minWaitingTime;
      state.orderManagerState.maxWaitingTime = payload.maxWaitingTime;
      state.orderManagerState.cannotOrderNow = payload.cannotOrderNow;
      state.orderManagerState.increaseTimeStep = payload.increaseTimeStep;
      state.orderManagerState.pendingOrdersIncreaseStep = payload.pendingOrdersIncreaseStep;
      state.orderManagerState.initTimeOfOrder = payload.initTimeOfOrder;
      state.orderManagerState.offTime = moment(payload.offTime, 'HH:mm');
      state.orderManagerState.isEnabled = payload.isEnabled;
    },

    SET_ORDER_PICKUP_TIME_STATE(state, payload) {
      console.log('SET_ORDER_PICKUP_TIME_STATE')
      console.log(payload)
      let index = state.orders.findIndex(i => { return i.orderId === payload.orderId});
      if(index > -1) {
        state.orders[index].pickupTime = payload.newPickupTime.format('HH:mm:ss');
        state.orders[index].asap = false;
      }
    },

    SET_ORDER_PRIORITY_ASAP_STATE(state, payload) {
      console.log('SET_ORDER_PRIORITY_ASAP_STATE')
      console.log(payload);
      let index = state.orders.findIndex(i => { return i.orderId === payload.orderId});
      let updatedPickupTime = moment(payload.newPickupTime,'HH:mm:ss');
      console.log(updatedPickupTime)
      if(index > -1) {
        state.orders[index].asap = payload.asap;
        state.orders[index].priority = payload.priority;
        state.orders[index].pickupTime = updatedPickupTime.format('HH:mm:ss');
        state.orders[index].state = payload.state;
      }
    },

    CANCEL_ORDER_STATE(state, payload) {
      //console.log('CANCEL ORDER STATE')
      //console.log(payload)
      let index = state.orders.findIndex(i => { return i.orderId === payload.orderId});
      //console.log(index)
      if(index > -1) {
        state.orders[index].status = 1;
      }
    }
}